module.exports = __webpack_public_path__ + "img/JA_web_subtitle.765db2eb.svg";